(function () {
  var SWIPE_THRESHOLD = 30;
  var currentSlides = new WeakMap();
  var swiping = false;
  var startX, startY, currentX, isDragging, container, track, slideCount, currentIndex;

  function findSwipeContainer(e) {
    var cardWrapper = e.target.closest('.card-wrapper--swipeable');
    if (!cardWrapper) return null;

    var swipe = cardWrapper.querySelector('.product-card-swipe');
    if (!swipe) return null;

    var rect = swipe.getBoundingClientRect();
    var touch = e.touches[0];
    if (
      touch.clientX < rect.left ||
      touch.clientX > rect.right ||
      touch.clientY < rect.top ||
      touch.clientY > rect.bottom
    ) {
      return null;
    }

    return swipe;
  }

  function onTouchStart(e) {
    container = findSwipeContainer(e);
    if (!container) return;

    track = container.querySelector('.product-card-swipe__track');
    slideCount = parseInt(container.dataset.swipeCount, 10);
    currentIndex = currentSlides.get(container) || 0;

    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    currentX = startX;
    isDragging = false;
    swiping = false;

    track.style.transition = 'none';
  }

  function onTouchMove(e) {
    if (!container) return;

    var touchX = e.touches[0].clientX;
    var touchY = e.touches[0].clientY;
    var deltaX = touchX - startX;
    var deltaY = touchY - startY;

    if (!isDragging) {
      if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 5) {
        isDragging = true;
        swiping = true;
      } else if (Math.abs(deltaY) > Math.abs(deltaX)) {
        container = null;
        return;
      }
    }

    if (isDragging) {
      e.preventDefault();
      currentX = touchX;
      var offset = -currentIndex * 100 + (deltaX / container.offsetWidth) * 100;
      track.style.transform = 'translateX(' + offset + '%)';
    }
  }

  function onTouchEnd() {
    if (!container || !isDragging) {
      container = null;
      return;
    }

    var deltaX = currentX - startX;
    track.style.transition = 'transform 0.3s ease';

    if (deltaX < -SWIPE_THRESHOLD && currentIndex < slideCount - 1) {
      currentIndex++;
    } else if (deltaX > SWIPE_THRESHOLD && currentIndex > 0) {
      currentIndex--;
    }

    track.style.transform = 'translateX(' + (-currentIndex * 100) + '%)';
    currentSlides.set(container, currentIndex);
    updateIndicators(container, currentIndex);

    container = null;

    setTimeout(function () {
      swiping = false;
    }, 300);
  }

  function updateIndicators(swipeContainer, index) {
    var card = swipeContainer.closest('.card');
    if (!card) return;
    var indicators = card.querySelectorAll('.product-card-swipe__indicator');
    indicators.forEach(function (ind, i) {
      ind.classList.toggle('product-card-swipe__indicator--active', i === index);
    });
  }

  function onClick(e) {
    if (swiping) {
      e.preventDefault();
      e.stopPropagation();
      swiping = false;
      return;
    }

    var swipeEl = e.target.closest('.product-card-swipe');
    if (swipeEl) {
      var card = swipeEl.closest('.card-wrapper');
      if (card) {
        var link = card.querySelector('a[href]');
        if (link) {
          window.location.href = link.href;
        }
      }
    }
  }

  function init() {
    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchmove', onTouchMove, { passive: false });
    document.addEventListener('touchend', onTouchEnd, { passive: true });
    document.addEventListener('click', onClick, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
